import service from "../config";

export function login(phone: string, code: string, areaCode: string, imageCode: string, uuid: string) {
  return service({
    url: "/deliver/v1/user/login",
    method: "post",
    data: { phone, code, areaCode, imageCode, uuid },
  });
}

export function getCode(phone: string, areaCode: string, imageCode: string, uuid: string) {
  return service({
    url: "/deliver/v1/getCode",
    method: "post",
    data: { phone, areaCode, imageCode, uuid },
  });
}

export function logOut(token: string) {
  return service({
    url: "/deliver/v1/user/logout",
    method: "post",
    data: { token },
  });
}
